import React from 'react';
import * as Styled from './styles';
import * as RiIcons from 'react-icons/ri';

interface IDialog {
  open: boolean;
  title?: string;
  children: React.ReactNode;
  onClose: () => void;
}

export function Dialog({ open, title, children, onClose }: IDialog) {
  
  if (!open) return null;

  return (
    <Styled.Overlay onClick={onClose}>
      <Styled.Container onClick={e => e.stopPropagation()}>
        <Styled.Header>
          <span>{title}</span>
          <button type="button" onClick={onClose}>
            <RiIcons.RiCloseLine size={22} />
          </button>
        </Styled.Header>
        <Styled.Content>{children}</Styled.Content>
      </Styled.Container>
    </Styled.Overlay>
  );
}
